import React, { Component } from "react";

export default class ReportCustomBenchmark extends Component {
  render() {
    const { benchmarks, labelAverage } = this.props;

    return (
      <div className="report_benchmark">
        <div className="report_benchmark__reference">
          <div className="report_benchmark__reference__line"></div>
          <div className="report_benchmark__reference__label">
            {labelAverage}
          </div>
        </div>
        <div className="report_benchmark__items">
          {/* A row with no content has no label to substitute the value into -
              question_lang.reportNumbers is missing for this language. Skipped
              rather than rendered as a bare unit, and it used to throw here. */}
          {benchmarks
            .filter((item) => item && item.content)
            .map((item, key) => (
              <div key={key} className="report_benchmark__item">
                <div
                  className="report_benchmark__item__label"
                  dangerouslySetInnerHTML={{
                    __html: item.content
                      .replace(
                        "XXX",
                        item.selfValue === 0.5111
                          ? "n/a"
                          : item.selfValue === 0.5112
                            ? "0"
                            : item.selfValue,
                      )
                      .replace("n/a%", "n/a"),
                  }}
                ></div>
                {/* 0.5111 is "n/a": no average, or no value to compare. */}
                <div className="report_benchmark__item__reference">
                  {item.otherValue === 0.5111
                    ? "n/a"
                    : item.unit === "%"
                      ? `${item.otherValue}%`
                      : `${item.otherValue} ${item.unit || ""}`}
                </div>
                <div className="report_benchmark__item__line">
                  <div
                    className="report_benchmark__item__line__indicator"
                    style={{
                      width: `${
                        item.otherValue === 0.5111 || item.selfValue === 0.5111
                          ? 0
                          : Math.min(
                              100,
                              (50 * item.selfValue) / item.otherValue,
                            )
                      }%`,
                    }}
                  ></div>
                </div>
              </div>
            ))}
        </div>
      </div>
    );
  }
}
